import { Injectable } from '@angular/core';
import {Store} from "@ngrx/store";
import * as componentActions from "@catdetails/actions/speaker-setup";

@Injectable()
export class ProjectSpeakerSetupService {

  constructor(private store: Store<any>) { }

  setActive() {
    this.store.dispatch({type: componentActions.PROJECT_SPEAKER_SETUP_ACTIVATE});
  }

  setInActive() {
    this.store.dispatch({type: componentActions.PROJECT_SPEAKER_SETUP_DEACTIVATE});
  }

}


// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/models/project-speaker-setup/services/project-speaker-setup.service.ts